export const OtpRegisterTranslations = {
  en: {
    otpRegister: {
      title: "Confirm",
      subtitle: "Enter the code we sent to your email {{email}}",
      invalidCode: "Please enter the 6-digit code",
      resendCode: "Resend Code",
      confirm: "Confirm",
    },
  },
  es: {
    otpRegister: {
      title: "Confirmar",
      subtitle: "Ingresa el código que enviamos a tu correo {{email}}",
      invalidCode: "Por favor ingresa el código de 6 dígitos",
      resendCode: "Reenviar código",
      confirm: "Confirmar",
    },
  },
};
